<h2 mat-dialog-title class="uk-text-center">
  @if (editMode) {
    Modifier
  } @else {
    Ajouter
  }
   une gare

</h2>

<mat-dialog-content>
	<form [formGroup]="form">
		<div class="uk-grid" style="padding-top: 10px">
			<div class="uk-width-1-2">
				<antm-input [type]="'text'" [placeHolder]="'Nom de la gare'" [controlName]="'name'" [form]="form" [required]="true"></antm-input>
			</div>
			<div class="uk-width-1-2">
				<antm-select [required]="true" [form]="form" [controlName]="'cityId'" [fieldName]="'Ville'" [valueList]="cities"></antm-select>
			</div>
		</div>

	</form>

</mat-dialog-content>

<mat-dialog-actions class="uk-flex uk-flex-center">
	<button matButton="filled" (click)="edit()">
		<ng-container *ngIf="!editMode">Ajouter</ng-container>
		<ng-container *ngIf="editMode">Modifier</ng-container>
	</button>
</mat-dialog-actions>
